
 /*
  *****************************************************************************
  * WARNING: This file is automatically generated.
  * Do not edit this file manually.
  *****************************************************************************
  * 
  * The source file is located at:
  *   /codebuild/output/src2984367493/src/vl-app/pages/wellbeinghub.tsx
  */

import { createFileRoute } from '@tanstack/react-router';
import WellbeingHub from './login';

export default WellbeingHub;
export const Route = createFileRoute('/wellbeinghub')({ component: WellbeingHub });
